<a [routerLink]="link()" routerLinkActive="active" [routerLinkActiveOptions]="activeOptions()" [attr.data-test]="testId()">
    @if (icon(); as name) {
        <app-icon [name]="name" />
    }
    <span>{{ label() }}</span>
</a>
